// Backward-compatibility helper for the postalCode / postalCodeString pair.
// postalCodeString is the new, free-text postal code field. Older data / consumers may
// only have postalCode populated (numeric). These helpers keep both fields in sync and
// provide a single place to read the "effective" postal code for display or export.

interface PostalCodeCarrier {
    postalCode?: number | string | null;
    postalCodeString?: string | null;
}

/**
 * Returns the postal code value that should be used for display/export purposes,
 * preferring postalCodeString and falling back to postalCode when it is not set.
 */
export function getEffectivePostalCode(obj: PostalCodeCarrier | null | undefined): string {
    if (!obj) {
        return "";
    }

    if (obj.postalCodeString !== null && obj.postalCodeString !== undefined && obj.postalCodeString !== "") {
        return obj.postalCodeString;
    }

    return obj.postalCode !== null && obj.postalCode !== undefined ? String(obj.postalCode) : "";
}

/**
 * Initializes postalCodeString from postalCode when postalCodeString has not been set yet.
 * Intended to be used when loading data for editing (e.g. onMounted in editors).
 */
export function syncPostalCodeStringFromNumber(obj: PostalCodeCarrier | null | undefined): void {
    if (!obj) {
        return;
    }

    if ((obj.postalCodeString === null || obj.postalCodeString === undefined || obj.postalCodeString === "")
        && obj.postalCode !== null && obj.postalCode !== undefined) {
        obj.postalCodeString = String(obj.postalCode);
    }
}

/**
 * Keeps the numeric postalCode in sync with postalCodeString before sending a request
 * to the backend, so that consumers only relying on postalCode keep working.
 */
export function syncPostalCodeFromString(obj: { postalCode: number | null; postalCodeString: string | null } | null | undefined): void {
    if (!obj) {
        return;
    }

    obj.postalCode =
        obj.postalCodeString !== null && obj.postalCodeString !== undefined && obj.postalCodeString !== "" && !isNaN(Number(obj.postalCodeString))
            ? Number(obj.postalCodeString)
            : null;
}
